import React from 'react';
import Style from './layout-suggestion.less';
import {
    PullPanelContent,
    PullPanelScene,
} from '@src/slide/application/service/slide-rating-and-improve/view/mobile/result/pull-panel-content';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import {
    IMobileRatingService,
} from '@src/slide/application/service/slide-rating-and-improve/mobile-slide-rating-service.interface';

export interface EditLayoutSuggestionContainerProps {
    getRatingService(): IDynamicService<IMobileRatingService> | undefined;
}

export class EditLayoutSuggestionContainer extends React.Component<EditLayoutSuggestionContainerProps> {
    private service: IMobileRatingService;
    public constructor(props) {
        super(props);
        this.props.getRatingService()?.promise()
            .then((service) => {
                this.service = service;
                this.setState({});
            });
    }

    public render() {
        return <div
            className={Style['layout-suggestion-container']}
            style={{ width: '100%', height: '100%', overflowY: 'auto' }}
        >
            {
                this.service
                && <PullPanelContent
                    scene={PullPanelScene.Edit}
                    analyzer={this.service.getAnalyser()}
                    mobileRatingService={this.service}
                    selectionService={this.service.getSelectionService()}
                />
            }
        </div>;
    }
}
